import { DynamicWorkspace } from 'components/Workspaces/Dynamic';

export default DynamicWorkspace;
